export default {
  socials: {
    facebook: 'https://facebook.com/clickability.com.au',
    linkedIn: 'https://www.linkedin.com/company/clickability---rated-reviewed-reliable',
    twitter: 'https://twitter.com/_clickability',
    blogEmail: 'blog@clickability.com.au',
    infoEmail: 'hello@clickability.com.au',
  },
  api: {
    URL:  process.env.REACT_APP_API_URL,
  },
  sentry: {
    DSN: process.env.REACT_APP_SENTRY_DSN,
  },
  website: {
    URL: process.env.REACT_APP_WEBSITE_URL,
  },
  phone: process.env.REACT_APP_PHONE,
  settings: {
    GTM_ID: process.env.REACT_APP_GTM_ID,
    CHAT_SCRIPT: process.env.REACT_APP_CHAT_SCRIPT,
    RECAPTCHA_KEY: process.env.REACT_APP_RECAPTCHA_KEY,
    BRAINTREE_SCRIPT: 'https://js.braintreegateway.com/web/dropin/1.26.0/js/dropin.min.js',
    BRAINTREE_CLIENT: 'https://js.braintreegateway.com/web/3.71.0/js/client.min.js',
    BRAINTREE_HOSTED_FIELDS: 'https://js.braintreegateway.com/web/3.71.0/js/hosted-fields.min.js',
  },
  lanternpay_auth: {
    CLIENT_ID: process.env.REACT_APP_LPAUTH_CLIENT_ID,
    AUTH_ENDPOINT: process.env.REACT_APP_LPAUTH_AUTH_ENDPOINT,
    SIGNUP_ENDPOINT: process.env.REACT_APP_LPAUTH_SIGNUP_ENDPOINT,
  },
  cognito: {
    BASE_URL: process.env.REACT_APP_COGNITO_BASE_URL,
    CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID,
  },
  stage: process.env.REACT_APP_STAGE,
  link: {
    faq: process.env.REACT_APP_FAQ_URL,
    providerFaq: process.env.REACT_APP_PROVIDER_FAQ_URL,
  },
};
